// src/api/adminAbandonedCheckouts.ts
import { V1, authFetch } from "api/client";

/**
 * One customer who opened checkout and did not pay: her newest unpaid order.
 * The backend lists only customers whose latest marketing decision is a grant,
 * and sends nothing about her health beyond the test she chose.
 */
export interface AbandonedCheckout {
  user_id: number;
  email: string | null;
  name: string | null;
  order_id: number;
  status: "payment_pending" | "failed";
  package_id: number | null;
  package_name: string | null;
  route: "clinic" | "mobile" | null;
  started_at: string; // ISO
}

export interface AbandonedCheckoutsOut {
  left_after_minutes: number;
  within_days: number;
  items: AbandonedCheckout[];
}

/** The defaults the page asks for: left over an hour ago, within the last 30 days. */
export const ABANDONED_DEFAULTS = { leftAfterMinutes: 60, withinDays: 30, limit: 200 } as const;

export async function adminListAbandonedCheckouts(
  opts: { leftAfterMinutes?: number; withinDays?: number; limit?: number } = {}
): Promise<AbandonedCheckoutsOut> {
  const params = new URLSearchParams({
    left_after_minutes: String(opts.leftAfterMinutes ?? ABANDONED_DEFAULTS.leftAfterMinutes),
    within_days: String(opts.withinDays ?? ABANDONED_DEFAULTS.withinDays),
    limit: String(opts.limit ?? ABANDONED_DEFAULTS.limit),
  });
  return authFetch<AbandonedCheckoutsOut>(
    `${V1}/admin/abandoned-checkouts?${params.toString()}`,
    { method: "GET" }
  );
}
